import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import React from 'react'

const caTheme = createTheme({ breakpoints: { values: { xs: 0, sm: 521, md: 769, lg: 1050, xl: 1200 } } })

export const CaThemeProvider = ({ children }) => (
  <MuiThemeProvider theme={caTheme}>
    {children}
  </MuiThemeProvider>
)
